export default {
  actions: {
    FETCH_WEEK: 'fetchWeek',
    FETCH_WEEK_UPDATE: 'fetchWeekUpdate',
    CREATE_BOOKING: 'createBooking',
    SAVE_EDITED_BOOKING: 'saveEditedBooking',
    DELETE_BOOKING: 'deleteBooking',
  },
  mutations: {
    RECEIVE_WEEK: 'receiveWeek',
    FETCHING_WEEK: 'fetchingWeek',
    CREATING_BOOKING: 'creatingBooking',
    BOOKING_CREATED: 'bookingCreated',
    BOOKING_CREATE_FAILED: 'bookingCreateFailed',
    EDITING_BOOKING: 'editingBooking',
    BOOKING_EDITED: 'bookingEdited',
    BOOKING_EDIT_FAILED: 'bookingEditFailed',
    DELETING_BOOKING: 'deletingBooking',
    BOOKING_DELETED: 'bookingDeleted',
    BOOKING_DELETE_FAILED: 'bookingDeleteFailed',
  },
  getters: {
    IS_FETCHING: 'isFetching',
    HAS_WEEK: 'hasWeek',
    GET_WEEK: 'getWeek',
    GET_BOOKINGS_BY_ROOM: 'getBookingsByRoom',
    GET_DAY_BY_ROOM: 'getDayByRoom',
    GET_BOOKING: 'getBooking',
    GET_CREATE_STATUS: 'getCreateStatus',
    GET_EDIT_STATUS: 'getEditStatus',
    GET_DELETE_STATUS: 'getDeleteStatus',
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/booking/types.js